import {t} from 'i18next';
import {useEffect} from 'react';
import IndexOverView from '../IndexingOverview/IndexingOverview';
import AurBreadcrumb from '../../common/aur-breadcrumb/AurBreadCrumb';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import IndexingBanner from '../IndexManagement/IndexingBanner';
import {Box} from '@mui/material';
import {EciHomePageTabs} from '../../../constants/constants';
import {setIndexingBannerData} from '../../../redux/slices/indexingManagementSlice';
import {
  getIndexingBannerFromIndexType,
  indexingStatusKey,
  isIndexingBannerShownByExistingLogic,
} from '../model';

const StandardIndexOverView = () => {
  const dispatch = useDispatch();
  const breadCrumbItems = [
    {
      label: t('eca.ecaHomepage.coreEciHome'),
      path: `/eci-home-page?tab=${EciHomePageTabs.ECI_OVERVIEW}`,
    },
    {
      label: t('ecaIndexing.manageIndexes'),
      path: '/indexmanagement',
    },
    {
      label: t('ecaIndexing.standardIndex'),
    },
  ];
  const indexing = useSelector(
    (state: RootState) => state.indexesBanner.indexBannerData
  );

  const indexDetails = useSelector(
    (state: RootState) => state.indexes.indexData
  );

  const skipApiBannerValidation = isIndexingBannerShownByExistingLogic(
    indexing?.showIndexBanner,
    indexDetails?.ele?.status
  );

  useEffect(() => {
    if (indexing?.showIndexBanner) {
      return;
    }

    if (indexDetails?.ele?.status === indexingStatusKey.inProgress) {
      dispatch(
        setIndexingBannerData(
          getIndexingBannerFromIndexType(indexDetails.ele?.type)
        )
      );
    }
  }, [
    dispatch,
    indexDetails?.ele?.status,
    indexDetails?.ele?.type,
    indexing?.showIndexBanner,
  ]);

  return (
    <div className="index-main-container">
      <div className="index-banner-container">
        {indexing?.showIndexBanner ? (
          <IndexingBanner message={indexing?.message} />
        ) : null}
      </div>
      <Box
        data-testid="breadcrumb-container"
        className={indexing?.showIndexBanner ? '' : 'empty-index'}
      >
        <AurBreadcrumb items={breadCrumbItems} />
      </Box>
      <IndexOverView
        title={indexDetails?.ele?.name}
        skipApiBannerValidation={skipApiBannerValidation}
      />
    </div>
  );
};

export default StandardIndexOverView;
